import { SEO } from '@/components/SEO';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function BlogPage() {
  const posts = [
    {
      title: '10 HR Trends to Watch in 2026',
      excerpt: 'Discover the latest trends shaping the future of human resources',
      date: '2026-01-15',
      category: 'Trends'
    },
    {
      title: 'How to Improve Employee Retention',
      excerpt: 'Proven strategies to keep your best talent engaged and satisfied',
      date: '2026-01-10',
      category: 'Best Practices'
    },
    {
      title: 'The ROI of HR Automation',
      excerpt: 'Calculate the real impact of automating your HR processes',
      date: '2026-01-05',
      category: 'ROI'
    },
  ];

  return (
    <>
      <SEO
        title="Blog - Nestor"
        description="Stay updated with the latest HR insights, trends, and best practices from industry experts."
      />

      <section className="bg-gradient-to-b from-primary/10 via-background to-background py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Blog</h1>
            <p className="text-xl text-muted-foreground">
              Insights, best practices, and the latest trends in HR
            </p>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto grid gap-6">
            {posts.map((post, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow cursor-pointer">
                <CardHeader>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground mb-2">
                    <span>{post.category}</span>
                    <span>•</span>
                    <span>{post.date}</span>
                  </div>
                  <CardTitle className="text-2xl">{post.title}</CardTitle>
                  <CardDescription className="text-base">{post.excerpt}</CardDescription>
                </CardHeader>
                <CardContent>
                  <span className="text-primary hover:underline">Read more →</span>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
